import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

export default WithDirection(styled.div`
    flex-grow: 1;
    display: flex;
    height: 100%;

    &.two-lines-result { max-width: 70%; }

    .Select {
        flex-grow: 1;
        display: flex;
        max-width: 100%;
        height: 100%;
        margin: 0 7px;
        z-index: 1;
    }
    .Select-arrow-zone,
    .Select-clear-zone,
    .Select-loading-zone { display: none; }

    .Select .Select-control {
        display: flex;
        align-items: center;
        border-width: 0;
        height: 100%;
        background-color: transparent !important;
        box-shadow: none !important;

        .Select-multi-value-wrapper { max-width: 100%; }
        .Select-placeholder { right: unset; padding-right: 0; padding-left: 21px; }

        .Select-input { max-width: 100%; padding-right: 0; }
        .Select-input input {
            box-sizing: border-box !important;
            border-width: 0;
            min-width: 20vw;
            max-width: 100%;
            width: auto !important;
            height: 100%;
            padding-right: 0;
    
            &:focus { outline-width: 0; }
        }
    }

    .Select-menu-outer {
        top: 100%;
        bottom: unset;
        transform: translate(-7px, 1px);

        .Select-option { display: flex; justify-content: space-between; align-items: center; }
        .Select-option img {
            margin-right: 10px;
            display: inline-block;
            width: 40px;
            height: 40px;
            border-radius: 3px;
        }
        .Select-option .app-name { flex-grow: 1; }
    }

    .two-lines-result {
        .Select-menu-outer .Select-option { flex-wrap: wrap; justify-content: flex-start; }
        .Select-menu-outer .Select-option:nth-child(even):not(:hover) { background-color: #efefef; }
        .Select-menu-outer .Select-option .app-name { width: calc(100% - 50px); word-break: break-word; }

        .Select-menu-outer .Select-option .owner {
            margin-top: 2px;
            border-top: 1px solid rgba(0, 0, 0, .3);
            width: 100%;
            padding-top: 2px;
            padding-left: 15%;
            text-align: right;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`);


// WEBPACK FOOTER //
// ./src/components/SearchAppBar/SelectWrapper.js